import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { gameInfos } from '@data/game.infos';
import { GameListItem } from '@domain/game.selection/game.list.item';
import { Instruction, LogoContainer } from '@domain/game.selection/game.list.styles';
import VersionContainer from '@domain/game.selection/version.container';
import Logo from '@assets/company/pipa-logo.svg';

export const GameList = () => {
  return (
    <Container maxWidth='lg'>
      <LogoContainer>
        <img src={Logo} alt='Pipa Studios' />
      </LogoContainer>

      <Instruction>Choose the game to manage</Instruction>

      <Grid container direction='row' spacing={4} alignContent='center' justify='center'>
        {gameInfos.map((g) => (
          <GameListItem key={g.urlId} game={g} />
        ))}
      </Grid>

      <VersionContainer />
    </Container>
  );
};
